exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reviews.component .review,.reviews.component .tripadvisor{display:table-cell;height:340px;vertical-align:middle}.reviews.component .meta{margin-top:-5px;font-family:Georgia,serif;font-weight:700;text-align:right}@media screen and (max-width:850px){.reviews.component .six.wide.column{width:351px}.reviews.component .four.wide.card.widget.column{width:193px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/widgets/reviews.less
 ** module id = 158
 ** module chunks = 0
 **/